var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container", [
    _c(
      "div",
      { staticClass: "app-container" },
      [
        _c(
          "el-card",
          { staticClass: "filter-container", attrs: { shadow: "never" } },
          [
            _c(
              "el-form",
              { attrs: { inline: true, model: _vm.queryParams } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "业务类型" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择", clearable: "" },
                        model: {
                          value: _vm.queryParams.where.biz_type,
                          callback: function($$v) {
                            _vm.$set(_vm.queryParams.where, "biz_type", $$v)
                          },
                          expression: "queryParams.where.biz_type"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "系统", value: "system" }
                        }),
                        _c("el-option", {
                          attrs: { label: "活动推广", value: "promo" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择", clearable: "" },
                        model: {
                          value: _vm.queryParams.where.status,
                          callback: function($$v) {
                            _vm.$set(_vm.queryParams.where, "status", $$v)
                          },
                          expression: "queryParams.where.status"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "已发布", value: 1 }
                        }),
                        _c("el-option", { attrs: { label: "草稿", value: 0 } }),
                        _c("el-option", { attrs: { label: "下线", value: -1 } })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-search" },
                        on: { click: _vm.handleQuery }
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh" },
                        on: { click: _vm.resetQuery }
                      },
                      [_vm._v("重置")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "action-bar" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "success", icon: "el-icon-plus" },
                on: { click: _vm.handleOpenSend }
              },
              [_vm._v("发送新消息")]
            )
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.list, border: "", stripe: "" }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "id", label: "ID", width: "70", align: "center" }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "biz_type",
                label: "业务类型",
                width: "100",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tag",
                        { attrs: { size: "small", effect: "plain" } },
                        [_vm._v(_vm._s(scope.row.biz_type))]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                prop: "title",
                label: "消息标题",
                "min-width": "150",
                "show-overflow-tooltip": ""
              }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "content",
                label: "消息内容",
                "min-width": "150",
                "show-overflow-tooltip": ""
              }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "status",
                label: "状态",
                width: "90",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: scope.row.status === 1 ? "success" : "info",
                            size: "small"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.status === 1 ? "已发送" : "待处理"
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { label: "作用范围", width: "90", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "small",
                            type: scope.row.scope === 1 ? "warning" : ""
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.scope === 1 ? "定向" : "全局") +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { label: "级别", width: "80", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "small",
                            type: scope.row.level === 1 ? "danger" : "info"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.level === 1 ? "重要" : "普通") +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                prop: "publish_time",
                label: "发布时间",
                width: "160",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.formatTimestamp(scope.row.publish_time))
                        )
                      ])
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                prop: "add_time",
                label: "添加时间",
                width: "160",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatTimestamp(scope.row.add_time)))
                      ])
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                width: "120",
                fixed: "right",
                align: "center"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      scope.row.status === 0
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.handleEdit(scope.row)
                                }
                              }
                            },
                            [_vm._v("编辑")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryParams.page,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.queryParams.limit,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange
              }
            })
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.isEdit ? "编辑消息" : "发送新消息",
              visible: _vm.sendVisible,
              width: "650px"
            },
            on: {
              "update:visible": function($event) {
                _vm.sendVisible = $event
              },
              close: _vm.resetSendForm
            }
          },
          [
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.sendLoading,
                    expression: "sendLoading"
                  }
                ],
                staticStyle: { padding: "20px" },
                attrs: { model: _vm.sendForm, "label-width": "100px" }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "消息标题" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入消息标题" },
                      model: {
                        value: _vm.sendForm.title,
                        callback: function($$v) {
                          _vm.$set(_vm.sendForm, "title", $$v)
                        },
                        expression: "sendForm.title"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "消息状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择状态" },
                                model: {
                                  value: _vm.sendForm.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sendForm, "status", $$v)
                                  },
                                  expression: "sendForm.status"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "发布", value: 1 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "草稿", value: 0 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "业务类型" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.sendForm.biz_type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sendForm, "biz_type", $$v)
                                  },
                                  expression: "sendForm.biz_type"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "系统", value: "system" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "活动推广", value: "promo" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "消息级别" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.sendForm.level,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sendForm, "level", $$v)
                                  },
                                  expression: "sendForm.level"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("普通")
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("重要")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "作用范围" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.sendForm.scope,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sendForm, "scope", $$v)
                                  },
                                  expression: "sendForm.scope"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "定向发送", value: 1 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "全局发送", value: 2 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "链接内容" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入链接地址或参数值" },
                      model: {
                        value: _vm.sendForm.link_value,
                        callback: function($$v) {
                          _vm.$set(_vm.sendForm, "link_value", $$v)
                        },
                        expression: "sendForm.link_value"
                      }
                    })
                  ],
                  1
                ),
                _vm.sendForm.scope === 1
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "用户编号" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              gap: "10px",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "",
                                  "auto-upload": false,
                                  "show-file-list": false,
                                  "on-change": _vm.handleExcelImport,
                                  accept: ".xlsx, .xls"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "primary",
                                      icon: "el-icon-upload2"
                                    }
                                  },
                                  [_vm._v("导入Excel")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "#909399",
                                  "line-height": "32px"
                                }
                              },
                              [_vm._v('请上传包含 "number" 列的 Excel')]
                            )
                          ],
                          1
                        ),
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder:
                              "请输入用户编号，多个用逗号分割，或通过上方按钮导入"
                          },
                          model: {
                            value: _vm.sendForm.numbers,
                            callback: function($$v) {
                              _vm.$set(_vm.sendForm, "numbers", $$v)
                            },
                            expression: "sendForm.numbers"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "消息内容" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 5,
                        placeholder: "请输入消息详情内容..."
                      },
                      model: {
                        value: _vm.sendForm.content,
                        callback: function($$v) {
                          _vm.$set(_vm.sendForm, "content", $$v)
                        },
                        expression: "sendForm.content"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.sendVisible = false
                      }
                    }
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.sendLoading },
                    on: { click: _vm.submitSend }
                  },
                  [_vm._v("确 定")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }